export const ZENDESK_WIDGET = 'ZENDESK_WIDGET'
